export const createOrderNumber = (now = Date.now(), cryptoSource = typeof window !== "undefined" ? window.crypto : undefined) => {
  const randomPart = cryptoSource?.randomUUID
    ? cryptoSource.randomUUID().replaceAll("-", "").slice(0, 12)
    : `${Math.random().toString(36).slice(2, 10)}${Math.random().toString(36).slice(2, 6)}`;

  return `MVM-${now.toString(36).toUpperCase()}-${randomPart.toUpperCase()}`;
};

export const buildPaymentPath = ({ orderNo, amount, currency, email, successUrl, cancelUrl, title }) => {
  const params = new URLSearchParams({
    orderNo,
    amount: Number(amount).toFixed(2),
    currency,
    email: email.trim(),
    success_url: successUrl,
    cancel_url: cancelUrl,
    title,
  });

  return `/create_payment.php?${params.toString()}`;
};
